module.exports = __webpack_public_path__ + "media/images/journey-8ff2cec0b1d13074fd4546e7a7a14fb9.jpg";